import { useEffect, useCallback, useState } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { useAuth } from '../context/auth'
import { useApplication } from '../context/application'

const AuthGate = () => {
  const { search } = useLocation()
  const { validateToken } = useAuth()
  const { updateApplication, getApplication } = useApplication()
  const [authAction, setAuthAction] = useState<{ redirect: boolean, to: string }>({ redirect: false, to: '' })

  const validateMagicLink = useCallback(async (token: string, redirect?: string) => {
    const user = await validateToken(token)

    if(user && user.role) {
      switch(user.role) {
        case 'Applicant':
          updateApplication({ applicant: {
            applicantId: user?.id,
            emailAddress: user?.email,
            isFirmAdministrator: user?.isFirmAdministrator,
            firstName: user.firstName,
            lastName: user.lastName
          }})
          const to = await getApplication()
          setAuthAction({ redirect: true, to })
          break;
        case 'Admin':
          let adminRedirectTo = '/admin'

          if(redirect?.includes('admin')) adminRedirectTo = redirect
          
          setAuthAction({ redirect: true, to: adminRedirectTo })
          break;
        case 'Client':
          let clientRedirectTo = '/customer'
          
          if(redirect?.includes('customer')) clientRedirectTo = redirect
          
          setAuthAction({ redirect: true, to: clientRedirectTo })
          break;
        default:
          setAuthAction({ redirect: true, to: `/unauthenticated${redirect ? '?redirect=' + redirect : ''}` })
      }
    } else {
      setAuthAction({ redirect: true, to: `/unauthenticated${redirect ? '?redirect=' + redirect : ''}` })
    }
  }, [getApplication, updateApplication, validateToken])
  
  useEffect(() => {
    const [tokenSplit, redirectSplit] = search.split('&')
    const token = tokenSplit.replace('?token=', '')
    const redirect = !!redirectSplit ? redirectSplit.replace('redirect=', '') : ''

    if(token) {
      validateMagicLink(token, redirect)
    } else {
      setAuthAction({ redirect: true, to: '/new' })
    }
  }, [search, validateMagicLink])

  return authAction.redirect ? <Navigate to={authAction.to} /> : null
}

export default AuthGate